module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/MediaObject-16e299ee3669bee19d7d40a9879d9bab.png";